import React, { useContext } from 'react';
import { SampleDataDispatchContext, SampleDataStateContext } from './SampleDataProvider';
import { CityTownDto, SAMPLEDATA_DELETE, SAMPLEDATA_UPDATE } from './sampleDataReducer';

interface DispatchType<payload> {
    type: string;
    payload?: payload;
}

export function useSampleData() {
    const sampleDataState = useContext(SampleDataStateContext);
    // Allow any below
    // eslint-disable-next-line
    const dispatch = useContext<React.Dispatch<DispatchType<any>>>(SampleDataDispatchContext);

    const { countries, cityTowns, populationSizes } = sampleDataState;

    const updateCityTown = async (cityTown: CityTownDto) => {
        await dispatch({
            type: SAMPLEDATA_UPDATE,
            payload: cityTown
        });
    }

    const deleteCityTowns = async (cityTowns: CityTownDto[]) => {
        await dispatch({
            type: SAMPLEDATA_DELETE,
            payload: cityTowns
        });
    }

    return { countries, cityTowns, populationSizes, updateCityTown, deleteCityTowns };
}
